import type { StepConfigItem } from './types';

export const customV59: StepConfigItem[] = [
  {
    name: 'customV2_startPageV34',
    hideHeader: true,
    progressTitle: 'customV2_progress_text15',
  },
  {
    name: 'customV2_policyPageV6',
    hideHeader: true,
  },
  {
    name: 'understanding',
  },
  {
    name: 'info_about_understanding',
    hideHeader: true,
  },
  {
    name: 'understanding_when',
  },
  {
    name: 'understanding_real_time',
  },
  {
    name: 'understanding_summary',
    hideHeader: true,
  },
  {
    name: 'customV2_play_frequency',
  },
  {
    name: 'customV2_play_games',
  },
  {
    name: 'customV2_play_behavior',
  },
  {
    name: 'customV2_play_ideas',
  },
  {
    name: 'customV2_breed',
  },
  {
    name: 'customV2_age',
  },
  {
    name: 'customV2_name',
  },
  {
    name: 'statement_strong_bond',
  },
  {
    name: 'customV2_creating_program',
    hideProgress: true,
  },
  {
    name: 'customV2_plan',
    hideProgress: true,
  },
  {
    name: 'customV2_email',
    hideProgress: true,
  },
  {
    name: 'receive_email',
    hideProgress: true,
  },
  {
    name: 'customV2_specialOffer_v2',
    hideProgress: true,
  },
];
